import { cx } from '@emotion/css';
import { animated, useSpring } from '@react-spring/web';

interface ItemProps {
  active?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}
const Item = (props: ItemProps) => {
  const { active = false, onClick, children } = props;

  const spring = useSpring({
    backgroundColor: active ? '#D6E8FF' : '#F0F2F5',
    color: active ? '#3370FF' : '#515359',
    config: {
      duration: 200,
    },
  });

  const className = cx(
    'inline-block h-[28px] px-2 text-[12px] leading-[28px] cursor-pointer select-none',
  );

  return (
    <animated.div style={spring} className={className} onClick={onClick}>
      {children}
    </animated.div>
  );
};

interface PackageTabsProps {
  className?: string;
  value: string | number;
  options: {
    value: string | number;
    label: string;
  }[];
  onChange: (value: string | number) => void;
}
export const PackageTabs = (props: PackageTabsProps) => {
  const { value, options, onChange, className } = props;

  return (
    <div
      className={cx(
        'inline-flex [&>*:first-child]:rounded-l [&>*:last-child]:rounded-r',
        className,
      )}
    >
      {options.map((item) => (
        <Item
          key={item.value}
          active={value === item.value}
          onClick={() => {
            onChange(item.value);
          }}
        >
          {item.label}
        </Item>
      ))}
    </div>
  );
};
